import { render, staticRenderFns } from "./JsonForm.vue?vue&type=template&id=e75a8488"
import script from "./JsonForm.vue?vue&type=script&lang=ts"
export * from "./JsonForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports